import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-a0357c5e")
const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = {
  key: 0,
  class: "radio-tab"
}
const _hoisted_3 = {
  key: 1,
  class: "container"
}
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "right" }
const _hoisted_10 = {
  key: 0,
  class: "card-content"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "pagination-area" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_arrow_right = _resolveComponent("arrow-right")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_message_manege = _resolveComponent("message-manege")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (['ALL_LEVEL'].includes(_ctx.userInfo.info.dataLevelEnm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_radio_group, {
            modelValue: _ctx.radio,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.radio = $event)),
            size: "small",
            onChange: _ctx.handleTabChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_button, { label: "我的消息" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.lang('messageCenter.msg.tabtype.[0]')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio_button, { label: "消息管理" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.lang('messageCenter.msg.tabtype.[1]')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.radio === '我的消息')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.messageList.length === 0)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 0,
                style: {"height":"90%"},
                description: _ctx.lang('messageCenter.msg.noData')
              }, null, 8, ["description"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_ctx.lang('messageCenter.msg.messageCenter')) + " ", 1),
                    (_ctx.systemMessage.unReadCount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.systemMessage?.unReadCount), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    class: "link",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleReadAll && _ctx.handleReadAll(...args)))
                  }, _toDisplayString(_ctx.lang('messageCenter.msg.read')), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageList, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: "message-card"
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["card-title", item.active && 'open']),
                        onClick: _withModifiers(($event: any) => (_ctx.handleChange(item)), ["stop"])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["left", !item.readFlag && 'dot'])
                        }, _toDisplayString(item.title), 3),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.formateDate(item.createTime)), 1),
                          _createVNode(_component_el_icon, {
                            size: 16,
                            style: {"top":"3px"}
                          }, {
                            default: _withCtx(() => [
                              (!item.active)
                                ? (_openBlock(), _createBlock(_component_arrow_right, { key: 0 }))
                                : (_openBlock(), _createBlock(_component_arrow_down, { key: 1 }))
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ], 10, _hoisted_8),
                      (item.active)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createTextVNode(_toDisplayString(item.content) + " ", 1),
                            (item.attachmentDesc)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  class: "link-button",
                                  onClick: _withModifiers(($event: any) => (_ctx.handleViewDetail(item.attachmentUrl, item.attachmentType)), ["stop"])
                                }, _toDisplayString(item.attachmentDesc), 9, _hoisted_11))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_el_pagination, {
                    background: "",
                    layout: "prev, pager, next",
                    total: _ctx.total,
                    "page-size": 10,
                    currentPage: _ctx.currentPage,
                    "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentPage = $event)),
                    onCurrentChange: _ctx.handleCurrentChange
                  }, null, 8, ["total", "currentPage", "onCurrentChange"])
                ])
              ], 64))
        ]))
      : (_openBlock(), _createBlock(_component_message_manege, { key: 2 }))
  ]))
}